<template>
  <div>
    <FaculdadeHeader />
    <FaculdadeIntro />
    <NoticiasGrid/>
    <CursoGrid />
    <PresidenteInfo />
    <Testemunhos />
  </div>
</template>

<script>
import FaculdadeHeader from "./home/FaculdadeHeader.vue";
import Testemunhos from './home/Testemunhos.vue';
import FaculdadeIntro from "./home/FaculdadeIntro.vue";
import CursoGrid from "./home/CursoGrid.vue";
import NoticiasGrid from "./home/NoticiasGrid.vue"
import PresidenteInfo from "./home/PresidenteInfo.vue";

export default {
  name: "Home",
  components:{
    CursoGrid,
    Testemunhos,
    FaculdadeHeader,
    FaculdadeIntro,
    NoticiasGrid,
    PresidenteInfo,
  }
}
</script>